import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumStockChangeReason implements BaseEnumType {
  private static allValues: EnumStockChangeReason[] = []; // make sure this is top-most
  
  public static none = new EnumStockChangeReason(0, "None", "enum_stock_change_reason_none");
  public static adjustmentIn = new EnumStockChangeReason(1, "AdjustmentIn", "enum_stock_change_reason_adjustment_in");
  public static adjustmentOut = new EnumStockChangeReason(2, "AdjustmentOut", "enum_stock_change_reason_adjustment_out");
  public static goodsIn = new EnumStockChangeReason(3, "GoodsIn", "enum_stock_change_reason_goods_in");
  public static goodsOut = new EnumStockChangeReason(4, "GoodsOut", "enum_stock_change_reason_goods_out");
  public static goodsReturned = new EnumStockChangeReason(5, "GoodsReturned", "enum_stock_change_reason_goods_returned");
  public static movementIn = new EnumStockChangeReason(6, "MovementIn", "enum_stock_change_reason_movement_in");
  public static movementOut = new EnumStockChangeReason(7, "MovementOut", "enum_stock_change_reason_movement_out");
  public static recoveredIn = new EnumStockChangeReason(8, "RecoveredIn", "enum_stock_change_reason_recovered_in");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockChangeReason.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumStockChangeReason.none; }
  public isAdjustmentIn() { return this === EnumStockChangeReason.adjustmentIn; }
  public isAdjustmentOut() { return this === EnumStockChangeReason.adjustmentOut; }
  public isGoodsIn() { return this === EnumStockChangeReason.goodsIn; }
  public isGoodsOut() { return this === EnumStockChangeReason.goodsOut; }
  public isGoodsReturned() { return this === EnumStockChangeReason.goodsReturned; }
  public isMovementIn() { return this === EnumStockChangeReason.movementIn; }
  public isMovementOut() { return this === EnumStockChangeReason.movementOut; }
  public isRecoveredIn() { return this === EnumStockChangeReason.recoveredIn; }

  public static getValues(): readonly EnumStockChangeReason[] {
    return EnumStockChangeReason.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockChangeReason[] {
    return EnumStockChangeReason.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockChangeReason {
    const found = EnumStockChangeReason.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockChangeReason - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockChangeReason): EnumStockChangeReason {
    const found = name ? EnumStockChangeReason.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockChangeReason - Value not found: ${ name }`);
    }

    return found;
  }
}